import axios from 'axios';
import { decrypt } from '../utils/Helper/encryption';

const apiKey = String(process.env.REACT_APP_API_KEY ?? '');

const apiCallWrapper = (path: string, method: string) => {
  const axiosInstance = axios.create();
  axiosInstance.interceptors.request.use((config) => {
    const adminEmail = sessionStorage.getItem('userEmail');
    const encryptedToken = sessionStorage.getItem('jwtToken');
    const loginPath: string = '/login';
    const forgotPath: string = '/reset/otp';
    const resetPath: string = '/reset/confirmpassword';
    const redirctUrlPath: string = '/resendurl';
    const orgAdminPath: string = '/organization/admin';
    const orgModulePath: string = '/organization/module';
    const orgUserPath: string = '/organization/user';
    const organisationUserPath: string = `/organization/user/${adminEmail}`;
    const assignedModulePath: string = '/module/assigneModule';
    const auditPath: string = '/auditHistory';
    const oauthToken: string = '/oauth/token';
    const oauthLogin: string = '/oauth/url';
    const switchuser: string = '/switchuser';
    const jwtToken = decrypt(encryptedToken);
    const role = sessionStorage.getItem('preferredRole');

    const setCommonHeaders = () => {
      config.headers.Authorization = `${jwtToken}`;
      config.headers['x-api-key'] = apiKey;
      config.headers.admin_email = adminEmail;
    };

    if (path === orgAdminPath) {
      if (method === 'GET' || method === 'PUT' || method === 'DELETE') {
        setCommonHeaders();
      } else {
        config.headers['x-api-key'] = apiKey;
      }
    } else if (path === auditPath && method === 'GET') {
      config.headers['x-api-key'] = apiKey;
    } else if (path === orgModulePath && method === 'GET') {
      setCommonHeaders();
    } else if (path === orgUserPath && method === 'POST') {
      setCommonHeaders();
      if (config.data?.orgEmail) {
        config.headers.admin_email = config.data.orgEmail;
      }
    } else if (path === assignedModulePath && method === 'POST') {
      setCommonHeaders();
    } else if (path === organisationUserPath && method === 'DELETE') {
      setCommonHeaders();
    } else if (
      path === loginPath ||
      path === redirctUrlPath ||
      path === forgotPath ||
      path === resetPath ||
      path === oauthToken ||
      path === oauthLogin
    ) {
      config.headers['x-api-key'] = apiKey;
    } else if (path === switchuser && method === 'POST') {
      config.headers.Authorization = `${jwtToken}`;
      config.headers['x-api-key'] = apiKey;
    } else {
      setCommonHeaders();
    }

    return config;
  });

  return axiosInstance;
};

export default apiCallWrapper;
